import Page from './driver-get-driver.container';

export default Page;
